var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExchangeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15595",
    transform: "translate(-700 -450)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 18296",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(700 450)",
    style: {
      fill: "#282d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12a12 12 0 1 0-12 12 12 12 0 0 0 12-12zM7 13h4V5h2v8h4l-5 6z",
    transform: "translate(708 458)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0A12 12 0 1 1 0 12 12.006 12.006 0 0 1 12 0zm2.085 14h-9v2h9v3l5-4-5-4v3zm-4-6V5l-5 4 5 4v-3h9V8h-9z",
    transform: "rotate(-90 595 -113)",
    style: {
      fill: "#696c80",
      fillRule: "evenodd"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/ExchangeIcon.2dde1b53.svg";
export { ForwardRef as ReactComponent };